import React from 'react';

// Shimmer styles
const shimmerStyles = `
  .shimmer {
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite;
  }
  
  @keyframes shimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }
  
  .shimmer-card {
    background: linear-gradient(90deg, #f8f9fa 25%, #e9ecef 50%, #f8f9fa 75%);
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite;
    border-radius: 8px;
  }
  
  .shimmer-text {
    background: linear-gradient(90deg, #e9ecef 25%, #dee2e6 50%, #e9ecef 75%);
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite;
    border-radius: 4px;
    height: 12px;
    margin: 4px 0;
  }
  
  .shimmer-title {
    background: linear-gradient(90deg, #e9ecef 25%, #dee2e6 50%, #e9ecef 75%);
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite;
    border-radius: 4px;
    height: 18px;
  }
  
  .shimmer-number {
    background: linear-gradient(90deg, #e9ecef 25%, #dee2e6 50%, #e9ecef 75%);
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite;
    border-radius: 4px;
    height: 20px;
    margin: 4px 0;
  }
  
  .shimmer-icon {
    background: linear-gradient(90deg, #e9ecef 25%, #dee2e6 50%, #e9ecef 75%);
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite;
    border-radius: 50%;
    width: 40px;
    height: 40px;
  }
  
  .shimmer-bar {
    background: linear-gradient(90deg, #e9ecef 25%, #dee2e6 50%, #e9ecef 75%);
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite;
    border-radius: 4px;
    height: 28px;
  }
  
  .shimmer-select {
    background: linear-gradient(90deg, #e9ecef 25%, #dee2e6 50%, #e9ecef 75%);
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite;
    border-radius: 4px;
    height: 28px;
    width: 100px;
  }
  
  .shimmer-donut {
    background: linear-gradient(90deg, #e9ecef 25%, #dee2e6 50%, #e9ecef 75%);
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite;
    border-radius: 50%;
  }
  
  .shimmer-legend {
    background: linear-gradient(90deg, #e9ecef 25%, #dee2e6 50%, #e9ecef 75%);
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite;
    border-radius: 4px;
    height: 12px;
    width: 80px;
  }
  
  .shimmer-legend-dot {
    background: linear-gradient(90deg, #e9ecef 25%, #dee2e6 50%, #e9ecef 75%);
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite;
    border-radius: 2px;
    width: 12px;
    height: 12px;
  }
`;

const Shimmer = ({ type, ...props }) => {
  // Add shimmer styles
  const ShimmerStyles = () => <style>{shimmerStyles}</style>;

  // Shimmer Card for UnitCountOne
  const ShimmerCard = () => (
    <div className="card shadow-sm border-0 h-100">
      <div className="card-body p-3 d-flex align-items-center">
        <div
          className="d-flex justify-content-center align-items-center rounded-circle me-3"
          style={{ width: "60px", height: "60px" }}
        >
          <div className="shimmer-icon"></div>
        </div>
        <div className="text-start flex-grow-1">
          <div className="shimmer-text" style={{ width: "80%", height: "12px" }}></div>
          <div className="shimmer-number" style={{ width: "60%", height: "20px", margin: "8px 0" }}></div>
          <div className="shimmer-text" style={{ width: "70%", height: "10px" }}></div>
        </div>
      </div>
    </div>
  );

  // Shimmer Chart for UnitCountOne
  const ShimmerChart = () => (
  <div className="card shadow-sm border-0" style={{ height: "310px" }}> {/* Fixed height add kiya */}
    <div className="card-body d-flex flex-column p-3" style={{ height: "100%" }}>
      <div className="shimmer-title" style={{ width: "40%", height: "18px", marginBottom: "20px" }}></div>
      <div className="flex-grow-1 d-flex flex-column">
        <div style={{ height: "250px", position: "relative" }}> {/* Chart area height fixed */}
          {[...Array(5)].map((_, i) => (
            <div
              key={i}
              className="shimmer-text"
              style={{
                position: "absolute",
                left: "0",
                top: `${i * 20}%`,
                width: "100%",
                height: "1px",
                opacity: 0.3
              }}
            ></div>
          ))}
          <div
            className="shimmer"
            style={{
              position: "absolute",
              top: "20%",
              left: "10%",
              width: "80%",
              height: "60%",
              borderRadius: "8px",
              opacity: 0.5
            }}
          ></div>
        </div>
        <div className="d-flex justify-content-between mt-3">
          {[...Array(7)].map((_, i) => (
            <div
              key={i}
              className="shimmer-text"
              style={{ width: "30px", height: "12px" }}
            ></div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

  // Shimmer Funnel for ParkingFunnel
  const ShimmerFunnel = () => (
    <div className="parking-funnel-container">
      {[...Array(4)].map((_, index) => (
        <div key={index} className="funnel-item d-flex align-items-center mb-16">
          <div className="funnel-label" style={{ minWidth: '120px' }}>
            <div className="shimmer-text" style={{ width: '80px', height: '12px' }}></div>
          </div>
          <div className="funnel-bar-container flex-grow-1 mx-3">
            <div
              className="shimmer-bar"
              style={{
                width: `${100 - index * 20}%`,
                height: '28px',
                minWidth: '20px'
              }}
            ></div>
          </div>
          <div className="funnel-value text-end" style={{ minWidth: '60px' }}>
            <div className="shimmer-number"></div>
          </div>
        </div>
      ))}
    </div>
  );

  // Shimmer Donut Chart for VehicleCheckinStatus
  const ShimmerDonutChart = () => (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div className="shimmer-title"></div>
        <div className="shimmer-select"></div>
      </div>
      <div className="d-flex justify-content-center my-4">
        <div style={{ width: '240px', height: '240px' }}>
          <div
            className="shimmer-donut"
            style={{
              width: '200px',
              height: '200px',
              margin: '20px auto',
              position: 'relative',
            }}
          >
            <div
              className="shimmer-donut"
              style={{
                width: '100px',
                height: '100px',
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                background: '#fff'
              }}
            ></div>
          </div>
        </div>
      </div>
      <ul className="d-flex flex-column gap-3 mt-3">
        {[...Array(3)].map((_, index) => (
          <li key={index} className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center gap-2">
              <div className="shimmer-legend-dot"></div>
              <div className="shimmer-legend"></div>
            </div>
            <div className="d-flex align-items-center gap-1">
              <div className="shimmer-text" style={{ width: '40px' }}></div>
              <div className="shimmer-text" style={{ width: '20px' }}></div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );

  // Shimmer Bar Chart for StaffPerformanceOverview
  const ShimmerBarChart = () => (
    <div>
      <div className="d-flex align-items-center flex-wrap gap-2 justify-content-between mb-20">
        <div>
          <div className="shimmer-title"></div>
          <div className="shimmer-text" style={{ width: '40px', marginTop: '8px' }}></div>
        </div>
        <div className="shimmer-select"></div>
      </div>
      <div className="chart-container" style={{ height: '280px', width: '100%' }}>
        <div style={{ position: 'relative', height: '100%', width: '100%' }}>
          {[...Array(4)].map((_, index) => (
            <div
              key={index}
              className="shimmer"
              style={{
                position: 'absolute',
                top: `${index * 25}%`,
                left: '5%',
                width: '90%',
                height: '1px',
                opacity: 0.3
              }}
            ></div>
          ))}
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-end',
              height: '80%',
              width: '90%',
              position: 'absolute',
              bottom: '10%',
              left: '5%',
              gap: '10px'
            }}
          >
            {[...Array(8)].map((_, index) => (
              <div
                key={index}
                className="shimmer-bar"
                style={{
                  width: '10%',
                  height: `${Math.random() * 60 + 20}%`,
                }}
              ></div>
            ))}
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              width: '90%',
              position: 'absolute',
              bottom: '0',
              left: '5%'
            }}
          >
            {[...Array(8)].map((_, index) => (
              <div
                key={index}
                className="shimmer-text"
                style={{ width: '40px', height: '12px' }}
              ></div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );

  const ShimmerModal = () => (
  <div>
    <ShimmerStyles />
    <div className="mb-3">
      <div className="shimmer-text" style={{ width: "100px", height: "12px", marginBottom: "8px" }}></div>
      <div className="shimmer-bar" style={{ width: "100%", height: "38px" }}></div>
    </div>
    <div className="mb-3">
      <div className="shimmer-text" style={{ width: "100px", height: "12px", marginBottom: "8px" }}></div>
      <div className="shimmer-bar" style={{ width: "100%", height: "80px" }}></div>
    </div>
    <div className="mb-3">
      <div className="shimmer-text" style={{ width: "100px", height: "12px", marginBottom: "8px" }}></div>
      <div className="shimmer-bar" style={{ width: "100%", height: "80px" }}></div>
    </div>
  </div>
);

// Inside the Shimmer component file, add this function
const ShimmerTaxRateModal = () => (
  <div>
    <ShimmerStyles />
    {/* Shimmer for Country Dropdown */}
    <div className="mb-3">
      <div className="shimmer-text" style={{ width: "100px", height: "12px", marginBottom: "8px" }}></div>
      <div className="shimmer-bar" style={{ width: "100%", height: "38px" }}></div>
    </div>
    {/* Shimmer for Tax Type Dropdown */}
    <div className="mb-3">
      <div className="shimmer-text" style={{ width: "100px", height: "12px", marginBottom: "8px" }}></div>
      <div className="shimmer-bar" style={{ width: "100%", height: "38px" }}></div>
    </div>
    {/* Shimmer for Tax Percent Input */}
    <div className="mb-3">
      <div className="shimmer-text" style={{ width: "120px", height: "12px", marginBottom: "8px" }}></div>
      <div className="shimmer-bar" style={{ width: "100%", height: "38px" }}></div>
    </div>
    {/* Shimmer for Active Select (optional, but included for edit mode) */}
    <div className="mb-3">
      <div className="shimmer-text" style={{ width: "80px", height: "12px", marginBottom: "8px" }}></div>
      <div className="shimmer-bar" style={{ width: "100%", height: "38px" }}></div>
    </div>
  </div>
);

  // Render based on type prop
  switch (type) {
    case 'card':
      return (
        <>
          <ShimmerStyles />
          <ShimmerCard />
        </>
      );
    case 'chart':
      return (
        <>
          <ShimmerStyles />
          <ShimmerChart />
        </>
      );
    case 'funnel':
      return (
        <>
          <ShimmerStyles />
          <ShimmerFunnel />
        </>
      );
    case 'donut':
      return (
        <>
          <ShimmerStyles />
          <ShimmerDonutChart />
        </>
      );
    case 'bar':
      return (
        <>
          <ShimmerStyles />
          <ShimmerBarChart />
        </>
      );
      case 'modal':
    return (
      <>
        <ShimmerStyles />
        <ShimmerModal />
      </>
    );
    case 'taxRateModal':
    return (
      <>
        <ShimmerStyles />
        <ShimmerTaxRateModal />
      </>
    );
    default:
      return null;
  }
};

export default Shimmer;